// extracted by mini-css-extract-plugin
export default {"vbBtnFab":"Lswv8__vbBtnFab km0_Y__vbUiBtn"};